import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100dvh;
  background-color: #f0f0f5;
`;

export const Header = styled.div`
  min-height: 6.4rem;
  display: flex;
  align-items: center;
  gap: 1.6rem;
  padding: 1.6rem 2rem;
  background-color: #3439a5;
  color: #fff;
  font-size: 2rem;
  font-weight: 500;

  @media (min-width: 768px) {
    padding: 1.8rem 3.2rem;
    font-size: 2.2rem;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding-bottom: 2rem;
`;

export const Button = styled.button`
  padding: 1.6rem 0rem;
  border-radius: 0.8rem;
  background-color: #3439a5;
  border: 0.1rem solid #2b2fa3;

  label {
    color: #fff;
    font-size: 1.6rem;
    font-weight: bold;
  }
`;

export const ContainerModal = styled.div`
  flex: 1;
  flex-direction: column;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f5;
  gap: 2.4rem;
`;

export const Text = styled.span`
  font-size: 1.6rem;
  text-align: center;
  font-family: "Heebo", sans-serif;
  background-color: #f0f0f5;
`;
